import React, { useState, useEffect } from 'react';
import { getCityById } from '../Utils/Locate';
const axios = require('axios').default;
const SearchResultItem = ({ vars }) => {
    const [attributes, setAttributes] = useState({
        cities: vars.cities,
        item: vars.item
    });
    const getCity = (item) => {
        let city = getCityById(attributes.cities, item.cityId);
        if (city == null) {
            return { name: "Tournai", slug: "tournai" };
        }
        return city;
    };
    // Load all functions for the current form
    useEffect(() => {
        return () => {
        };
    }, []);
    let item = attributes.item;
    let city = getCity(item);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `search-result-item scheme-${item.category}` },
            React.createElement("div", { className: "picture" },
                React.createElement("img", { src: item.poster, alt: "{item.name}" })),
            React.createElement("div", { className: "content" },
                React.createElement("div", null,
                    React.createElement("h2", null,
                        React.createElement("a", { href: item.link }, item.name)),
                    city != null ?
                        (React.createElement("div", { className: "address with-pointer" },
                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "16.667", viewBox: "0 0 14 16.667" },
                                React.createElement("g", { transform: "translate(1 1)" },
                                    React.createElement("path", { d: "M16.5,7.5c0,4.667-6,8.667-6,8.667s-6-4-6-8.667a6,6,0,0,1,12,0Z", transform: "translate(-4.5 -1.5)", fill: "none", stroke: "#113cdd", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
                                    React.createElement("path", { d: "M17.566,12.533A2.033,2.033,0,1,1,15.533,10.5,2.033,2.033,0,0,1,17.566,12.533Z", transform: "translate(-9.533 -6.525)", fill: "none", stroke: "#113cdd", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }))),
                            React.createElement("span", null, city.name)))
                        : "",
                    React.createElement("p", { className: "tags" },
                        React.createElement("span", { className: `tag power ${item.category == "adv" ? "white" : ""}` }, item.categoryName)))),
            React.createElement("div", { className: "description", dangerouslySetInnerHTML: { __html: item.description } }))));
};
export default SearchResultItem;
